var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.89993 4.20039H8.09993M3.89993 6.30039H8.09993M3.89993 8.40039H5.99993M2.84976 1.40039H9.14989C9.9231 1.40039 10.5499 2.02721 10.5499 2.80042L10.5497 11.2004C10.5497 11.9736 9.92291 12.6004 9.14973 12.6004L2.8497 12.6004C2.0765 12.6004 1.4497 11.9736 1.44971 11.2004L1.44976 2.80038C1.44977 2.02719 2.07657 1.40039 2.84976 1.40039Z",
    stroke: "#616874",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFile);
export default __webpack_public_path__ + "static/media/upload_file.f96de1fa3d3379889c9691fc5c624c14.svg";
export { ForwardRef as ReactComponent };